module.exports = __webpack_public_path__ + "static/media/hallway_to_hell_pt2.07c5f690.png";